import { render, staticRenderFns } from "./Dataanalysis.vue?vue&type=template&id=5b49e76a&scoped=true&"
import script from "./Dataanalysis.vue?vue&type=script&lang=js&"
export * from "./Dataanalysis.vue?vue&type=script&lang=js&"
import style0 from "./Dataanalysis.vue?vue&type=style&index=0&id=5b49e76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b49e76a",
  null
  
)

export default component.exports